/* eslint-disable */
import axios from 'axios';
import { jsonp } from '@ifeng-fe/ui_base';
import { IndexUrl } from '@src/constants';
import detail from './detail.json';
import { Grounds } from '@ifeng-fe/client_grounds';

let url = NODE_ENV === 'production' ? 'https://external-gateway.ifengidc.com' : 'https://external-gateway.ifengidc.com';

function isMobile() {
    const flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);

    return flag;
}

export let whichEnv = () => {
    if (window.grounds) {
        return 'client';
    } else {
        // 手机端
        if (isMobile()) {
            return 'mobile';
        }
        // pc端
        else {
            return 'pc';
        }
    }
};
export let getToken = () => {
    // 客户端

    if (whichEnv() === 'client') {
        return window.grounds.getUserInfo().getToken();
    }
    if (isWechat()) {
        if (!window.localStorage.getItem('token')) {
            const callback = encodeURIComponent(`https://id.ifeng.com/sso/v1/?redirect=${encodeURIComponent(IndexUrl)}`);

            const linkurl = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx9bd3b38f9c278ab4&redirect_uri=${callback}&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect`;

            window.location.href = linkurl;
        }
        return window.localStorage.getItem('token');
        //return  '42771C27FD6E4C3285C62293FB01EC56'
    } else {
        return window.localStorage.getItem('token');
    }
};

export const getAllData = async (voteId) => {
    const token = getToken();
    console.log(token);
    try {
        const data = await axios(`${voteUrl}/315/get.php?sid=${token}&vid=${voteId}`, {
            type: 'get',
            cache: false,
        });
        console.log(data);
        if (data.status === 200) {
            return data.data;
        }
    } catch (e) {
        console.error(e);
    }
};

export const getAllDataNew = async (voteId, year) => {
    const token = getToken();
    // console.log(token);
    try {
        // const data = await axios(`${voteUrl}/315/2026/get.php?year=${year}&sid=AD7275BFF77860AB5F021C2E0242E41A&vid=${voteId}`, {
        const data = await axios(`${voteUrl}/315/2026/get.php?year=${year}&sid=${token}&vid=${voteId}`, {
            type: 'get',
            cache: false,
        });
        // console.log(data);
        if (data.status === 200) {
            return data.data;
        }
    } catch (e) {
        console.error(e);
    }
};

export const currentVoteStatus = async (id) => {
    const { data } = await axios({
        method: 'get',
        url: `${url}/vote/api/currentVoteStatus?voteIds=${id}`,
        headers: {
            token: getToken(),
            // TODO : 用于测试
            //token:'2687BFBFD337D0F27090FAFBF2171EF2'
        },
    });

    if (data?.code === 200) {
        return data.data;
    }
};
export const submitVote = async (data) => {
    const token = getToken();

    const res = await axios({
        method: 'post',
        url: `${voteUrl}/315/post.php?sid=${token}`,
        data,
    });
    console.log(JSON.stringify(res), 'res-----');
    return res;
};

export const submitAllVote = async (data, year) => {
    const token = getToken();

    const res = await axios({
        method: 'post',
        url: `${voteUrl}/315/2026/post.php?year=${year}&sid=${token}`,
        data,
    });
    return res;
};

export const submitApi = async ({ content, docUrl, docName}) => {

    let ext2Json = {
        docUrl: docUrl,
        type: 'web'
    };
    let ext2 = JSON.stringify(ext2Json);
    let data = await jsonp(
        `${commentUrl}/post.php?docUrl=${encodeURIComponent(encodeURIComponent(docUrl))}&docName=${encodeURIComponent(docName)}&skey=&format=js&content=${content}&ext2=${encodeURIComponent(ext2)}&permalink=http%3A%2F%2Ftest.news.ifeng.com%2Floc%2Fresult`,
        {
            jsonpCallback: 'postCmt',
            cache: false,
        }
    );
    return data;
};
export const getTempCommentList = async (doc_url) => {
    const data = await jsonp(`${commentUrl}/get/tempcomment`, {
        data: {
            doc_url,
            format: 'js',
        },
        jsonpCallback: 'getTempComments',
        cache: false,
    });

    // 格式化评论数据
    return data;
};

//获取hot 标识的索引
export async function getHostIndex() {
    try {
        const data = await axios(`${voteUrl}/315/industry.php`, {
            type: 'get',
            cache: false,
        });
        console.log(data);

        return data.data.data;
    } catch (e) {
        console.error(e);
    }
}

//获取行业接口
export async function getindustryList(year) {
    try {
        const data = await axios(`${voteUrl}/315/2026/industry.php?year=${year}`, {
            type: 'get',
            cache: false,
        });
        console.log(data);

        return data.data;
    } catch (e) {
        console.error(e);
    }
}

// 获取评论数据
export const getHotList = async (docUrl, page = 1) => {
    const data = await jsonp(`${commentUrl}/get.php`, {
        data: {
            orderby: 'uptimes',
            docUrl: encodeURIComponent(docUrl),
            // docUrl: 'ucms_8hQXZvJVhnU',
            format: 'js',
            job: 1,
            p: page,
            pageSize: 100,
            skey: '',
        },
        jsonpCallback: 'callback' + Math.random().toString(36).substring(2, 10) ,// 加个随机字符串，要求字母数字组合

        cache: false,
    });

    // 按 create_time 倒序
    if (data && Array.isArray(data.comments)) {
        data.comments.sort((a, b) => (Number(b.create_time) || 0) - (Number(a.create_time) || 0));
    }

    return data;
};
export const goNewPage = (url) => {
    if (window.grounds) {
        Grounds.dispatch({
            link: { type: 'web', url },
            pageLogParams: { ref: '' },
        });
    } else {
        window.location.href = url;
    }
};
export let getHeaderHeight = () => {
    if (window.grounds) {
        //window.grounds.setMultiToolBarHidden(true);
    } else {
        return 0;
    }
};
export function isWechat() {
    return /MicroMessenger/i.test(window.navigator.userAgent);
}
